// initial state
const state = () => ({
  showButtons: true,
  showProfileDetails: false,
  wrongAnswers: [],
});

// getters
const getters = {
  getShowButtons: state => {
    return state.showButtons;
  },
  getShowProfileDetails: state => {
    return state.showProfileDetails;
  },
  getWrongAnswers: state => {
    return state.wrongAnswers;
  },
};

// actions
const actions = {
  reset({ commit }) {
    commit('setInit');
  },
  showButtons({ commit }, value) {
    commit('setShowButtons', value);
  },
  toggleShowButtons({ commit, state }) {
    commit('setShowButtons', !state.showButtons);
  },
  showProfileDetails({ commit }, value) {
    commit('setProfileDetails', value);
  },
  toggleShowProfileDetails({ commit, state }) {
    commit('setProfileDetails', !state.showProfileDetails);
  },
  addWrongAnswer({ commit }, value) {
    commit('addWrongAnswer', value);
  },
};

// mutations
const mutations = {
  setInit: (state) => {
    state.showButtons = true;
    state.showProfileDetails = false;
    state.wrongAnswers = [];
  },
  setShowButtons: (state, val) => {
    state.showButtons = val;

  },
  setProfileDetails: (state, val) => {
    state.showProfileDetails = val;
  },
  addWrongAnswer: (state, val) => {
    if (!state.wrongAnswers.includes(val)) {
      state.wrongAnswers.push(val);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
